import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import RiversGraph from './RiversGraph';
import s from './rivers.css';

const minInitSpeed = 1;
const maxInitSpeed = 5;

class Rivers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initSpeed: 3.0,
    };
  }

  handleInitSpeed(evt) {
    this.setState({ initSpeed: parseFloat(evt.target.value) });
  }

  render() {
    return (
      <div>
        <div>
          Initial Speed: {minInitSpeed} m/s &nbsp;
          <input
            id="init-speed"
            type="range"
            value={this.state.initSpeed}
            min={minInitSpeed}
            max={maxInitSpeed}
            step="0.1"
            onChange={(evt) => this.handleInitSpeed(evt)}
          />
          &nbsp; {maxInitSpeed} m/s
        </div>
        <RiversGraph initSpeed={this.state.initSpeed} />
      </div>
    );
  }
}

export default withStyles(s)(Rivers);



// WEBPACK FOOTER //
// src/components/Rivers/Rivers.js